import React, { useEffect, useRef } from 'react';
import { NavLink } from 'react-router-dom';
import { useSelector } from 'react-redux';
import AnalyticsManager from '../../../../app/analytics';
import { combineClassNames, getMediaPath } from '../../../../app/functions';
import DynamicLink from '../../../../components/dynamic_link';
import './index.scss';

const ItemWrapper = React.forwardRef((props, ref) => {
    const { children, ...remainingProps } = props;

    if (props.to) {
        return (
            <NavLink ref={ref} {...remainingProps}>
                {children}
            </NavLink>
        );
    }

    if (props.link) {
        return (
            <DynamicLink data={props.link} {...remainingProps}>
                {children}
            </DynamicLink>
        );
    }

    return (
        <div ref={ref} {...remainingProps}>
            {children}
        </div>
    );
});

const MegaMenuItem = ({
    id,
    text,
    icon,
    to,
    onClick = () => {},
    direction = 'rtl',
    iconClassName = '',
    textClassName = '',
    hover = false,
    link = null,
}) => {
    const navRef = useRef();

    const megaMenuId = useSelector((store) => store.state.megaMenuId);

    const handleItemClick = () => {
        AnalyticsManager.logMenuItemPress(text);
        onClick();
    };

    useEffect(() => {
        document.addEventListener('mouseover', onHover);

        return () => {
            document.removeEventListener('mouseover', onHover);
        }
    }, []);

    const onHover = (event) => {
        if (!hover) return;

        const isChild = event.composedPath().indexOf(navRef.current) !== -1;

        if (megaMenuId === id) return;
        if (!isChild) return;

        onClick(id, true);
    };

    return (
        <ItemWrapper
            ref={navRef}
            className={combineClassNames(
                'mega-menu-item-wrapper',
                megaMenuId === id && 'bold',
                textClassName,
            )}
            data-hbo={'mega-menu-item-wrapper'}
            onClick={!hover ? handleItemClick : () => {}}
            style={{ flexDirection: direction === 'rtl' ? 'row' : 'row-reverse' }}
            to={to}
            link={link}
        >
            {text}

            {icon && (
                <img
                    src={getMediaPath(icon)}
                    alt="Icon"
                    className={combineClassNames(
                        'dropdown-arrow',
                        megaMenuId === id && 'open',
                        iconClassName,
                    )}
                />
            )}
        </ItemWrapper>
    );
};

export default MegaMenuItem;
